import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  submitForgotPassword,
  setUsername,
  setLoginMode,
  submitMagicLink,
} from '../../../Actions/Login.action';
import { useTypedSelector } from '../../../Hooks/useTypedSelector';
import { translate } from '../../../Services/translation';
import LoginMode from '../../../Types/LoginMode';
import Input from '../../Inputs/Input';
import clsx from 'clsx';

const LoginForgotPassword = () => {
  const {
    username = '',
    isLoading,
    magicLinkModel,
  } = useTypedSelector((state) => state.login);
  const [isSuccessful, setIsSuccessful] = useState(false);
  const dispatch = useDispatch();

  const onSubmit = (e?: any) => {
    if (e) {
      e.preventDefault();
    }
    dispatch(submitForgotPassword(username)).then((success) =>
      setIsSuccessful(success)
    );
  };

  useEffect(() => {
    // Send magic link on first render only, if magic link model is in state
    if (!magicLinkModel?.link) return;
    dispatch(submitMagicLink(magicLinkModel));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <h1 className="mb-2">
        {!magicLinkModel ? (
          translate('login.forgot-password')
        ) : (
          <>{translate('general.loading')}...</>
        )}
      </h1>
      <div className="mb-6 text-xl">
        {translate('login.forgot-password.intro-text')}
      </div>
      {!isSuccessful && !magicLinkModel && (
        <>
          <form className="mb-7" onSubmit={onSubmit}>
            <Input
              wrapperClassName="mb-4"
              label={translate('general.placeholder.username')}
              showAnimatedLabel={true}
              inputSize="large"
              value={username}
              onChange={(e) => dispatch(setUsername(e.target.value))}
              type="email"
            />
            <button
              className="btn btn--black btn--large w-full"
              type="submit"
              disabled={isLoading}
            >
              {!isLoading && translate('general.send')}
              {isLoading && translate('general.loading')}
            </button>
          </form>
          <div
            className={clsx(
              'flex',
              'flex-col',
              'items-center',
              'text-center'
            )}
          >
            <button
              className="underlined-link col-span-2 mx-auto self-start text-sm uppercase after:w-full"
              onClick={() => dispatch(setLoginMode(LoginMode.Login))}
              disabled={isLoading}
            >
              {!isLoading && translate('general.back')}
              {isLoading && translate('general.loading')}
            </button>
          </div>
        </>
      )}
      {isSuccessful && (
        <>
          <p className={clsx('text-base', 'mt-4')}>
            {translate('login.forgot-password.email-sent')}
          </p>
          <div className={clsx('flex', 'flex-col', 'mt-6')}>
            <button
              className="btn btn--clear btn--large w-full"
              onClick={() => dispatch(setLoginMode(LoginMode.Login))}
            >
              {translate('general.back')}
            </button>
          </div>
        </>
      )}
    </>
  );
};

export default LoginForgotPassword;
